import { render, staticRenderFns } from "./SlideShowSection.vue?vue&type=template&id=415d8e11&scoped=true&"
import script from "./SlideShowSection.vue?vue&type=script&lang=js&"
export * from "./SlideShowSection.vue?vue&type=script&lang=js&"
import style0 from "./SlideShowSection.vue?vue&type=style&index=0&id=415d8e11&lang=scss&scoped=true&"
import style1 from "./SlideShowSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415d8e11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
